export const PLAIN_TEXT_CLIPBOARD_MIMETYPE = 'text/plain';
export const HTML_CLIPBOARD_MIMETYPE = 'text/html';
export const PNG_CLIPBOARD_MIMETYPE = 'image/png';

export const copyToClipboard = async (text: string): Promise<void> => {
  await window.PMW.copyToClipboard(text);
};

export const copyTextAndImageToClipboard = async (text: string, imageBlob: Blob): Promise<void> => {
  if (!isImageClipboardSupported()) {
    await copyToClipboard(text);
    return;
  }
  try {
    await navigator.clipboard.write([
      new ClipboardItem({
        [PLAIN_TEXT_CLIPBOARD_MIMETYPE]: new Blob([text], {type: PLAIN_TEXT_CLIPBOARD_MIMETYPE}),
        [imageBlob.type]: imageBlob,
      }),
    ]);
  } catch {
    await copyToClipboard(text);
  }
};

export const readFromClipboard = async (): Promise<string> => {
  return window.PMW.readFromClipboard();
};

export const isClipboardAPISupported = (): boolean => {
  return navigator.clipboard !== undefined;
};

export const isImageClipboardSupported = (): boolean => {
  return typeof ClipboardItem !== 'undefined' && navigator.clipboard?.write !== undefined;
};

export const copyPngToClipboard = async (pngBlobPromise: Promise<Blob>): Promise<void> => {
  await navigator.clipboard.write([new ClipboardItem({[PNG_CLIPBOARD_MIMETYPE]: pngBlobPromise})]);
};

export const extractFilesFromClipboard = (items: DataTransferItemList | undefined): File[] => {
  if (!items) {
    return [];
  }
  const files: File[] = [];
  for (const item of items) {
    const file = item.kind === 'file' ? item.getAsFile() : null;
    if (file) {
      files.push(file);
    }
  }

  return files;
};

export const extractImageFilesFromClipboard = (items: DataTransferItemList | undefined): File[] =>
  extractFilesFromClipboard(items).filter((file) => file.type.startsWith('image/'));
